import { createElement } from 'react';
import { y as Drawer$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Drawer = function Drawer(props) {
  return /*#__PURE__*/createElement(Drawer$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
Drawer.displayName = 'Drawer';

export { Drawer };
